import { Component, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { SubscriptionUtil } from 'src/app/_utilities/subscription';
import { FormGroup, FormControl, Validators} from "@angular/forms";
import { UsersService } from 'src/app/_services/admin/users.service';
import { WorkflowService } from "src/app/_services/workflow.service";
import { ErrorUtil } from "src/app/_utilities/error";
import { AssetService } from 'src/app/_services/asset.service';
import {UtilServiceService} from 'src/app/_services/utilService/util-service.service';

interface ReminderRow {
  id?: any | null;
  timing: string | null;
  channel: string | null;
  notification: number | null;
  notificationList: any | [];
  notificationListInApp?: any | [];
  notificationInApp?: number | null;
}
interface Frequency {
  fName: string | null;
  fVal: number | null;
}

@Component({
  selector: "app-configure-certificate",
  standalone: false,
  templateUrl: "./configure-certificate.component.html",
  styleUrl: "./configure-certificate.component.scss",
})
export class ConfigureCertificateComponent
  extends SubscriptionUtil
  implements OnInit, OnDestroy
{
  translate: any;
  defaultDate = new Date();
  minDate = new Date(new Date().setHours(0, 0, 0, 0));
  notificationPlaceholderText: string = "Select Notification";

  timingOptions = [
    { label: "1 day before due", value: 1 },
    { label: "3 days before due", value: 3 },
    { label: "7 days before due", value: 7 },
    { label: "14 days before due", value: 14 },
    { label: "30 days before due", value: 30 },
    { label: "60 days before due", value: 60 },
    { label: "90 days before due", value: 90 },
    // { label: "On due date", value: "ON_DUE" },
    // { label: "1 day after due", value: "1_DAY_AFTER" },
  ];

  channelOptions = [
    { label: "Email", value: "Email" },
    { label: "In-app", value: "InApp" },
    { label: "Email & In-App", value: "Both" },
  ];

  // ── DUMMY Reminder rows state ───────────────────────────────────────────────────────

  reminders: ReminderRow[] = [
    // { timing: "30_DAYS", channel: "EMAIL" },
    // { timing: "30_DAYS", channel: "EMAIL" },
    // { timing: "30_DAYS", channel: "EMAIL" },
  ];
  certificateTypesForm: FormGroup;
  frequencyList: Frequency[] = [
    { fName: "Every 3 Months", fVal: 3 },
    { fName: "Every 6 Months", fVal: 6 },
    { fName: "Every 12 Months", fVal: 12 },
    { fName: "Every 18 Months", fVal: 18 },
    { fName: "Every 24 Months", fVal: 24 },
    { fName: "Every 5 Years", fVal: 5 },
  ];
  userGroups: any;
  notificationList: any;
  notificationListInApp: any;
  data: any;
  dueDateOptions: any = [
    {
      name: "Completed Date",
      value: "COMPLETED_DATE",
    },
    {
      name: "Due Date",
      value: "DUE_DATE",
    },
  ];

  constructor(
    private languageTranslateService: LanguageTranslateService,
    private modalRef: BsModalRef,
    private userService: UsersService,
    private workFlowServc: WorkflowService,
    private errorUtil: ErrorUtil,
    private bsModalServc: BsModalService,
    private assetServc: AssetService,
    private util: UtilServiceService,
  ) {
    super();
    this.certificateTypesForm = new FormGroup({
      name: new FormControl(null, [
        Validators.required,
        Validators.pattern(/^(?=.*[a-zA-Z])[a-zA-Z0-9\s]+$/),
        Validators.maxLength(255),
      ]),
      frequency: new FormControl("", [Validators.required]),
      authority: new FormControl("", [Validators.maxLength(255)]),
      notify: new FormControl(null),
      //isMandatory: new FormControl(false),
      startDate: new FormControl(null, [Validators.required]),
      dueDateDerivation: new FormControl(null, [Validators.required]),
      sendNoti: new FormControl(false),
    });
  }

  ngOnInit(): void {
    this.getLanguageData();
    if (this.data.mode == "edit" && this.data.module == "assetType") {
      this.certificateTypesForm.patchValue({
        name: this.data.data.name,
        frequency: this.data.data.frequency,
        authority: this.data.data.authority,
        notify: this.data.data.notifyCompletionUserGroupId,
        //isMandatory: this.data.data.isMandatory,
        startDate: this.util.formatISOStringToDate(this.data.data.startDate),
        dueDateDerivation: this.data.data.dueDateDerivation,
        sendNoti: this.data.data.sendCompletionNotification,
      });

      let sDateVal: any = this.util.formatISOStringToDate(this.data.data.startDate);
      if (sDateVal < this.minDate) {
        //update the minDate to be start date value
        this.minDate = new Date(sDateVal.setHours(0,0,0,0));
      }

      this.data.data.notificationConfigs.map((reminder: any) => {
        this.reminders.push({
          id: reminder.id,
          timing: reminder.daysBefore,
          channel:
            reminder.email && reminder.inApp
              ? "Both"
              : reminder.inApp
                ? "InApp"
                : reminder.email
                  ? "Email"
                  : null,
          notification:
            reminder.inApp && reminder.email
              ? reminder.emailWorkflowAlertId
              : reminder.email
                ? reminder.emailWorkflowAlertId
                : reminder.inApp
                  ? reminder.inAppWorkflowAlertId
                  : null,
          notificationList: [],
          notificationInApp:
            reminder.inApp && reminder.email
              ? reminder.inAppWorkflowAlertId
              : null,
        });
      });
    } else if (this.data.mode == "edit" && this.data.module == "asset") {
      this.certificateTypesForm.patchValue({
        name: this.data.data.assetCertificationType.name,
        frequency: this.data.data.assetCertificationType.frequency,
        authority: this.data.data.assetCertificationType.authority,
        notify:
          this.data.data.assetCertificationType.notifyCompletionUserGroupId,
        //isMandatory: this.data.data.isMandatory,
        startDate: this.util.formatISOStringToDate(
          this.data.data.assetCertificationType.startDate,
        ),
        dueDateDerivation:
          this.data.data.assetCertificationType.dueDateDerivation,
        sendNoti:
          this.data.data.assetCertificationType.sendCompletionNotification,
      });

      let sDateVal: any = this.util.formatISOStringToDate(this.data.data.assetCertificationType.startDate);
      if (sDateVal < this.minDate) {
        //update the minDate to be start date value
        this.minDate = new Date(sDateVal.setHours(0,0,0,0));
      }

      this.data.data.assetCertificationType.notificationConfigs.map(
        (reminder: any) => {
          this.reminders.push({
            id: reminder.id,
            timing: reminder.daysBefore,
            channel:
              reminder.email && reminder.inApp
                ? "Both"
                : reminder.inApp
                  ? "InApp"
                  : reminder.email
                    ? "Email"
                    : null,
            notification:
              reminder.inApp && reminder.email
                ? reminder.emailWorkflowAlertId
                : reminder.email
                  ? reminder.emailWorkflowAlertId
                  : reminder.inApp
                    ? reminder.inAppWorkflowAlertId
                    : null,
            notificationList: [],
            notificationInApp:
              reminder.inApp && reminder.email
                ? reminder.inAppWorkflowAlertId
                : null,
          });
        },
      );
    } else {
    }
    //add form control based on reminders array
    this.reminders.map((rem: any, index: number) => {
      this.certificateTypesForm.addControl(
        "notiFreq" + index,
        new FormControl(rem.timing, [Validators.required]),
      );
      this.certificateTypesForm.addControl(
        "notiType" + index,
        new FormControl(rem.channel, [Validators.required]),
      );
      this.certificateTypesForm.addControl(
        "noti" + index,
        new FormControl(rem.notification, [Validators.required]),
      );

      if (rem.channel == "Both") {
        this.certificateTypesForm.addControl(
          "notiInApp" + index,
          new FormControl(rem.notificationInApp, [Validators.required]),
        );
      }

      this.onChannelChange({ value: rem.channel }, index);

      this.certificateTypesForm.controls["notiFreq" + index].updateValueAndValidity();
      this.certificateTypesForm.controls["notiType" + index].updateValueAndValidity();
    });

    this.certificateTypesForm.updateValueAndValidity();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  getLanguageData() {
    this.push(
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
          this.getUserGroupsData();
        }
      }),
    );
  }

  getUserGroupsData() {
    this.push(
      this.userService.getAlluserGroup().subscribe((data: any) => {
        this.userGroups = data;
      }),
    );
  }

  push(obs: any) {
    super.push(obs);
  }

  onCancelClick(): void {
    this.bsModalServc.setDismissReason("cancelled");
    this.modalRef.hide();
  }

  //forces every reminder row to be destroyed/recreated whenever the list length changes,
  //so formControlName{{i}} directives re-bind to the reindexed controls instead of
  //sticking to whichever control they were first wired to
  trackByReminder = (index: number, _reminder: ReminderRow) => {
    return index + "_" + this.reminders.length;
  };

  addReminder(): void {
    if (this.reminders.length >= 3) return;
    this.reminders.push({
      id: null,
      timing: null,
      channel: null,
      notification: null,
      notificationList: [],
      notificationListInApp: [],
    });
    //add form control based on reminders array

    this.certificateTypesForm.addControl(
      "notiFreq" + (this.reminders.length - 1),
      new FormControl("", [Validators.required]),
    );
    this.certificateTypesForm.addControl(
      "notiType" + (this.reminders.length - 1),
      new FormControl("", [Validators.required]),
    );
    this.certificateTypesForm.addControl(
      "noti" + (this.reminders.length - 1),
      new FormControl("", [Validators.required]),
    );

    this.certificateTypesForm.controls[
      "notiFreq" + (this.reminders.length - 1)
    ].updateValueAndValidity();
    this.certificateTypesForm.controls[
      "notiType" + (this.reminders.length - 1)
    ].updateValueAndValidity();
    this.certificateTypesForm.controls[
      "noti" + (this.reminders.length - 1)
    ].updateValueAndValidity();

    this.certificateTypesForm.updateValueAndValidity();
    console.log(this.certificateTypesForm, "form printing after adding");
  }

  removeReminder(idx: number, row: any): void {
    const index = this.reminders.indexOf(row);
    if (index === -1) return;

    const controlNames = ["notiFreq", "notiType", "noti", "notiInApp"];
    const total = this.reminders.length;

    //snapshot current control values before re-indexing
    const snapshot = Array.from({ length: total }, (_, i) => ({
      notiFreq: this.certificateTypesForm.get("notiFreq" + i)?.value,
      notiType: this.certificateTypesForm.get("notiType" + i)?.value,
      noti: this.certificateTypesForm.get("noti" + i)?.value,
      notiInApp: this.certificateTypesForm.contains("notiInApp" + i)
        ? this.certificateTypesForm.get("notiInApp" + i)?.value
        : null,
    }));

    this.reminders.splice(index, 1);
    snapshot.splice(index, 1);
    //drop every indexed control, then re-add them reindexed to match the reminders array
    for (let i = 0; i < total; i++) {
      controlNames.forEach((name) => {
        if (this.certificateTypesForm.contains(name + i)) {
          this.certificateTypesForm.removeControl(name + i);
        }
      });
    }

    snapshot.forEach((values, i) => {
      this.certificateTypesForm.addControl(
        "notiFreq" + i,
        new FormControl(values.notiFreq, [Validators.required]),
      );
      this.certificateTypesForm.addControl(
        "notiType" + i,
        new FormControl(values.notiType, [Validators.required]),
      );
      this.certificateTypesForm.addControl(
        "noti" + i,
        new FormControl(values.noti, [Validators.required]),
      );
      if (values.notiType === "Both") {
        this.certificateTypesForm.addControl(
          "notiInApp" + i,
          new FormControl(values.notiInApp, [Validators.required]),
        );
      }
    });

    this.certificateTypesForm.updateValueAndValidity();
    console.log(this.certificateTypesForm, 'form printing after delete')
  }

  onChannelChange(e: any, index: number) {
    if (e) {
      if (e.value !== "Both") {
        this.notificationPlaceholderText = "Select Notification";
        if (this.certificateTypesForm.contains("notiInApp" + index)) {
          // control exists
          this.certificateTypesForm.removeControl("notiInApp" + index);
          this.certificateTypesForm.updateValueAndValidity();
        }
        this.push(
          this.workFlowServc
            .getListOfWorkflowsNotification("AssetCertificationRecord", e.value)
            .subscribe({
              next: (res: any) => {
                if (res.status == 200) {
                  this.notificationList = res.body;
                  this.reminders[index].notificationList =
                    this.notificationList;
                  if (this.data.mode == "edit") {
                    //in edit mode, patch the form value
                    this.certificateTypesForm.patchValue({
                      ["noti" + index]: this.reminders[index].notification,
                    });
                    this.certificateTypesForm.controls[
                      "noti" + index
                    ].updateValueAndValidity();
                    this.certificateTypesForm.updateValueAndValidity();
                  }
                }
              },
              error: (err: any) => {
                console.log(err, "error in GET workflow alerts by module api");
                this.errorUtil.setErrorMessage(
                  err.status,
                  err.error ? err.error.title : null,
                  err.error ? err.error.title : null,
                  "error",
                  2000,
                );
              },
            }),
        );
      } else {
        //if both
        this.notificationPlaceholderText = "Select Notification for Email";
        this.certificateTypesForm.addControl(
          "notiInApp" + index,
          new FormControl("", [Validators.required]),
        );
        this.certificateTypesForm.controls[
          "notiInApp" + index
        ].updateValueAndValidity();

        this.push(
          this.workFlowServc
            .getListOfWorkflowsNotification("AssetCertificationRecord", "Email")
            .subscribe({
              next: (res: any) => {
                if (res.status == 200) {
                  this.notificationList = res.body;
                  this.reminders[index].notificationList =
                    this.notificationList;
                  if (this.data.mode == "edit") {
                    //in edit mode, patch the form value
                    this.certificateTypesForm.patchValue({
                      ["noti" + index]: this.reminders[index].notification,
                    });
                    this.certificateTypesForm.controls[
                      "noti" + index
                    ].updateValueAndValidity();
                    this.certificateTypesForm.updateValueAndValidity();
                  }
                }
              },
              error: (err: any) => {
                this.errorUtil.setErrorMessage(
                  err.status,
                  err.error ? err.error.title : null,
                  err.error ? err.error.title : null,
                  "error",
                  2000,
                );
              },
            }),
        );

        this.push(
          this.workFlowServc
            .getListOfWorkflowsNotification("AssetCertificationRecord", "InApp")
            .subscribe({
              next: (res: any) => {
                if (res.status == 200) {
                  this.notificationListInApp = res.body;
                  this.reminders[index].notificationListInApp =
                    this.notificationListInApp;

                  if (this.data.mode == "edit") {
                    //in edit mode, patch the form value
                    this.certificateTypesForm.patchValue({
                      ["notiInApp" + index]:
                        this.reminders[index].notificationInApp,
                    });
                    this.certificateTypesForm.controls[
                      "notiInApp" + index
                    ].updateValueAndValidity();
                    this.certificateTypesForm.updateValueAndValidity();
                  }
                }
              },
              error: (err: any) => {
                console.log(err, "error in GET workflow alerts by module api");
                this.errorUtil.setErrorMessage(
                  err.status,
                  err.error ? err.error.title : null,
                  err.error ? err.error.title : null,
                  "error",
                  2000,
                );
              },
            }),
        );
      }
    }
  }

  addCertificateType() {
    if (this.certificateTypesForm.valid) {
      let configs: any = [];
      let payload: any = {
        asset: null,
        name: this.certificateTypesForm.get("name")?.value,
        frequency: this.certificateTypesForm.get("frequency")?.value,
        frequencyType:
          this.certificateTypesForm.get("frequency")?.value == 5
            ? "YEAR"
            : "MONTH",
        authority: this.certificateTypesForm.get("authority")?.value,
        startDate: this.util.formatDateToISOString(
          this.certificateTypesForm.get("startDate")?.value,
        ),
        dueDateDerivation:
          this.certificateTypesForm.get("dueDateDerivation")?.value,
        sendCompletionNotification:
          this.certificateTypesForm.get("sendNoti")?.value,
        notifyCompletionUserGroup: this.certificateTypesForm.get("sendNoti")
          ?.value
          ? {
              id: this.certificateTypesForm.get("notify")?.value,
            }
          : null,
      };

      if (this.data.mode == "create") {
        if (this.data.module == "asset") {
          payload.asset = {
            id: this.data.data, //asset id from certificate setting component when cert typ is in create mode
          };
        } else {
          payload["assetsType"] = {
            id: this.data.data, //asset type id from certificate setting component when cert typ is in create mode
          };
        }

        //construct the notifconfig array
        this.reminders.map((rem: any, idx: number) => {
          configs.push({
            daysBefore: this.certificateTypesForm.get("notiFreq" + idx)?.value,
            inApp:
              this.certificateTypesForm.get("notiType" + idx)?.value ==
                "InApp" ||
              this.certificateTypesForm.get("notiType" + idx)?.value == "Both"
                ? true
                : false,
            email:
              this.certificateTypesForm.get("notiType" + idx)?.value ==
                "Email" ||
              this.certificateTypesForm.get("notiType" + idx)?.value == "Both"
                ? true
                : false,
            emailWorkflowAlert:
              this.certificateTypesForm.get("notiType" + idx)?.value ==
                "Email" ||
              this.certificateTypesForm.get("notiType" + idx)?.value == "Both"
                ? {
                    id: this.certificateTypesForm.get("noti" + idx)?.value,
                  }
                : null,
            inAppWorkflowAlert:
              this.certificateTypesForm.get("notiType" + idx)?.value == "InApp"
                ? {
                    id: this.certificateTypesForm.get("noti" + idx)?.value,
                  }
                : this.certificateTypesForm.get("notiType" + idx)?.value ==
                    "Both"
                  ? {
                      id: this.certificateTypesForm.get("notiInApp" + idx)
                        ?.value,
                    }
                  : null,
          });
        });

        payload.notificationConfigs = configs;
        this.push(
          this.assetServc.createAssetCertType(payload).subscribe({
            next: (res: any) => {
              if (res.status == 200 || res.status == 201) {
                this.errorUtil.setErrorMessage(
                  200,
                  "Certificate Type has been added successfully",
                  null,
                  "success",
                  5000,
                );

                let jsonObj: any = {
                  reason: "cert-type-added",
                };
                this.bsModalServc.setDismissReason(JSON.stringify(jsonObj));
                this.modalRef.hide();
              }
            },
            error: (err: any) => {
              console.log(err, "error from add cert type");
              this.errorUtil.setErrorMessage(
                err.status,
                err.error ? err.error.title : null,
                err.error ? err.error.title : null,
                "error",
                2000,
              );
            },
          }),
        );
      } else {
        //update
        this.reminders.map((rem: any, idx: number) => {
          configs.push({
            id: rem.id,
            daysBefore: this.certificateTypesForm.get("notiFreq" + idx)?.value,
            inApp:
              this.certificateTypesForm.get("notiType" + idx)?.value ==
                "InApp" ||
              this.certificateTypesForm.get("notiType" + idx)?.value == "Both"
                ? true
                : false,
            email:
              this.certificateTypesForm.get("notiType" + idx)?.value ==
                "Email" ||
              this.certificateTypesForm.get("notiType" + idx)?.value == "Both"
                ? true
                : false,
            emailWorkflowAlert:
              this.certificateTypesForm.get("notiType" + idx)?.value ==
                "Email" ||
              this.certificateTypesForm.get("notiType" + idx)?.value == "Both"
                ? {
                    id: this.certificateTypesForm.get("noti" + idx)?.value,
                  }
                : null,
            inAppWorkflowAlert:
              this.certificateTypesForm.get("notiType" + idx)?.value == "InApp"
                ? {
                    id: this.certificateTypesForm.get("noti" + idx)?.value,
                  }
                : this.certificateTypesForm.get("notiType" + idx)?.value ==
                    "Both"
                  ? {
                      id: this.certificateTypesForm.get("notiInApp" + idx)
                        ?.value,
                    }
                  : null,
          });
        });

        payload.notificationConfigs = configs;
        if (this.data.module == "asset") {
          payload.asset = {
            id: this.data.data.assetId, //asset id from certificate setting component when cert type is in edit mode
          };
          payload["id"] = this.data.data.assetCertificationType.id;
        } else {
          payload["assetsType"] = {
            id: this.data.data.assetTypeId, //asset type id from certificate setting component when cert type is in edit mode
          };
          payload["id"] = this.data.data.id;
        }

        this.push(
          this.assetServc.updateAssetCertType(payload).subscribe({
            next: (res: any) => {
              if (res.status == 200 || res.status == 201) {
                this.errorUtil.setErrorMessage(
                  200,
                  "Certificate Type has been updated successfully",
                  null,
                  "success",
                  5000,
                );
                let jsonObj: any = {
                  reason: "cert-type-updated",
                };
                this.bsModalServc.setDismissReason(JSON.stringify(jsonObj));
                this.modalRef.hide();
              }
            },
            error: (err: any) => {
              console.log(err, "error from add cert type");
              this.errorUtil.setErrorMessage(
                err.status,
                err.error ? err.error.title : null,
                err.error ? err.error.title : null,
                "error",
                2000,
              );
            },
          }),
        );
      }
    }
  }

  onSendNotiChanged(event: any) {
    if (event.checked === true) {
      this.certificateTypesForm.controls["notify"].setValidators([
        Validators.required,
      ]);
    } else {
      this.certificateTypesForm.controls["notify"].clearValidators();
    }
    this.certificateTypesForm.controls["notify"].updateValueAndValidity();
    this.certificateTypesForm.updateValueAndValidity();
  }
}
